import { PublisherChip, SchoolInfoChip } from '@/shared/components/Chip/QuizInfoChip';
import { SubjectChip } from '@/shared/components/SubjectChip';
import { cn } from '@/utils';
import { type HeroCardData } from '../../types';
type CategoryChipsProps = {
  category?: HeroCardData['category'];
  className?: string;
};
export const CategoryChips = ({
  category,
  className
}: CategoryChipsProps) => {
  if (!category) return null;
  return <div className={cn('flex items-center gap-3xs', className)} data-sentry-component="CategoryChips" data-sentry-source-file="CategoryChips.tsx">
      <SchoolInfoChip schoolInfo={category} data-sentry-element="SchoolInfoChip" data-sentry-source-file="CategoryChips.tsx" />
      {category.subjectName && <SubjectChip {...category} className="border-alternative bg-default" />}
      <PublisherChip publisherId={category.publisher} data-sentry-element="PublisherChip" data-sentry-source-file="CategoryChips.tsx" />
    </div>;
};